const CLICK_SIGN_BUTTON = "CLICK_SIGN_BUTTON";
const SEND = "SEND";
const GET_LOGIN = "GET_LOGIN";
const GET_PASSWORD = "GET_PASSWORD";

export {
    CLICK_SIGN_BUTTON,
    SEND,
    GET_LOGIN,
    GET_PASSWORD
}